import React, {Component, useEffect, useState} from 'react';
import { FaUserAlt, FaLock } from "react-icons/fa";
import { Redirect} from "react-router-dom";

import './SignIn.css';
import back from '../../assets/Group 1.svg';
import {connect} from "react-redux";
import { useMutation } from '@apollo/client';
import { LOGIN_USER } from '../../queries';
import { setLogin } from '../../redux';
;

const SignIn = (props) => {
  const [ login, { data, /*loading,*/ error }] = useMutation(LOGIN_USER);
  const [errorLog, setErrorLog] = useState('');

    useEffect(()=>{
        if(error) {
            setErrorLog(error.message);
        }
    }, [error]);


  return (
    <SignInForm login={login} redux={props} token={data ? data.login : null} errorLog = {errorLog}/>
  )
}


class SignInForm extends Component{
    constructor(props) {
        super(props);
        this.state = {
            user: '',
            pass: '',
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
          [name]: value
        });
    }

    async handleSubmit(event) {
        event.preventDefault();

        const o = { variables: {
          password: this.state.pass,
          username: this.state.user,
        }};

        try {
          await this.props.login(o);

          this.props.redux.handleSignIn();
          // this.props.redux.handleToken(this.props.token);
          localStorage.setItem('token', this.props.token);

          // redirect
          // window.location = '/';
        }
        catch (e) {
        }
    }

    render() {
        if (this.props.token) {
            return (< Redirect to="/" />);
        }
        return (
            <form onSubmit={this.handleSubmit}>
                <div className="container-fluid m-0 p-0">
                    <div className="signcontain">
                        <div className="row m-0 p-0 row1">
                            <div className="col-md-6 logcol p-0 m-0">
                                <div className="login-box">
                                    <h1>Sign In</h1>
                                    <div className="textbox">
                                        <FaUserAlt className="user"/>
                                        <input
                                            name="user"
                                            type="text"
                                            placeholder="Username"
                                            onChange={this.handleInputChange}
                                            value={this.state.user}
                                        />
                                    </div>

                                    <div className="textbox">
                                        <FaLock className="pass"/>
                                        <input
                                            name="pass"
                                            type="password"
                                            placeholder="Password"
                                            onChange={this.handleInputChange}
                                            value={this.state.pass}
                                        />
                                    </div>
                                    {this.props.errorLog ?
                                        <p className="errorMsg">{this.props.errorLog}</p>:
                                        <></>
                                    }
                                    <button type="submit" className="btn btnsign">Sign in</button>

                                    <div className="text">
                                        <p><a href="/account/changePass">Forgot password?</a></p>
                                        <p><span>No account? </span><a href="/register">Create one</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 backg m-0 p-0">
                                <div className="background">
                                    <img src={back} alt="logo" className="logoback"/>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </form>
        )
    }
}

const mapStateToProps = (state) =>{
    return{
        isLogIn : state.isLogIn,
        token   : state.token,
    }
}

const mapDispatchToProps = (dispatch) =>{
    return{
        handleSignIn : () => dispatch(setLogin()),
        handleSignOut : () => dispatch(setLogin()),
        // handleToken : (token) => dispatch(setToken(token)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
